import { ErrorBoundary as ReactErrorBoundary } from "react-error-boundary";
import { useNavigate, useLocation } from "react-router-dom";

function ErrorBoundaryWrapper({ children }) {
  const navigate = useNavigate();
  const location = useLocation();

  const handleError = () => {
    sessionStorage.setItem("errorReturnPath", location.pathname);
    navigate(`/error?reason=render`);
  };

  return (
    <ReactErrorBoundary onError={handleError} fallback={null}>
      {children}
    </ReactErrorBoundary>
  );
}

export default ErrorBoundaryWrapper;
